import { produce } from 'immer';

import {
  EDITING_DOCUMENTS_DOMAIN_DATA_INITIALIZE,
  EDITING_DOCUMENTS_LIST_FETCH_REQUEST,
  EDITING_DOCUMENTS_LIST_FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { EditingDocumentsAction } from '@app/store/editingDocuments/actions';
import EditingDocument from '@app/store/editingDocuments/EditingDocument';

interface EditingDocumentsById {
  [id: string]: EditingDocument;
}

const initialState: EditingDocumentsById = {};

export default function reducer(
  state: EditingDocumentsById = initialState,
  action: EditingDocumentsAction
) {
  switch (action.type) {
    case EDITING_DOCUMENTS_DOMAIN_DATA_INITIALIZE:
    case EDITING_DOCUMENTS_LIST_FETCH_REQUEST:
      return initialState;
    case EDITING_DOCUMENTS_LIST_FETCH_SUCCESS:
      return produce(state, (draft) => {
        if (draft) {
          const { editingDocuments } = action.payload;
          editingDocuments.forEach((editingDocument) => {
            draft[editingDocument.editingDocumentId] = editingDocument;
          });
        }
      });
    default:
      return state;
  }
}
